import { Card } from '../primitives/card';
import { Skeleton } from '../primitives/skeleton';
import { cn } from '../lib/cn';

interface LoadingStateProps {
  /** Shape of the page that is loading, so the layout does not jump when data arrives */
  variant?: 'list' | 'cards' | 'detail';
  /** Announced to screen readers, e.g. "Loading jobs" */
  label?: string;
  className?: string;
}

/** Placeholder while a page loads. Tables have their own skeleton rows (DataTable `loading`). */
export function LoadingState({ variant = 'list', label = 'Loading', className }: LoadingStateProps) {
  return (
    <div role="status" aria-label={label} className={cn('grid gap-4', className)}>
      {variant === 'cards' && (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }, (_, i) => (
            <Card key={i} className="grid gap-2 p-5">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-8 w-14" />
            </Card>
          ))}
        </div>
      )}
      {variant === 'list' &&
        Array.from({ length: 4 }, (_, i) => (
          <Card key={i} className="grid gap-2 p-5">
            <Skeleton className="h-5 w-2/3 max-w-80" />
            <Skeleton className="h-4 w-1/2 max-w-60" />
          </Card>
        ))}
      {variant === 'detail' && (
        <div className="grid items-start gap-4 lg:grid-cols-[minmax(0,1fr)_20rem]">
          <Card className="grid gap-3 p-5 lg:order-last">
            <Skeleton className="h-5 w-24" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </Card>
          <Card className="grid gap-3 p-5">
            <Skeleton className="h-6 w-1/2" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </Card>
        </div>
      )}
    </div>
  );
}
